import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { dismissValidationError } from 'actions/errors'
import { inviteeEmailErrorsSelector } from 'selectors'
import BookingField from 'components/enter_details/booking_field'
import BookingTextField from 'components/form/text'
import { useI18n } from 'locales'

import { usePurchasedPackageData } from '../../../../../hooks/usePurchasedPackageData'
import { eventTypeSelector } from '../../../../../root-api'

const EmailInput = ({ email: { value, required }, onChange }) => {
  const { i18n } = useI18n()
  const emailErrors = useSelector(inviteeEmailErrorsSelector)
  const { uuid } = useSelector(eventTypeSelector)
  const { purchasedPackage } = usePurchasedPackageData(uuid)

  const dispatch = useDispatch()
  const dismissError = () => dispatch(dismissValidationError('invitee', 'email'))

  const handleChange = (...args) => {
    dismissError()
    onChange(...args)
  }

  const disable = Boolean(purchasedPackage)

  return (
    <BookingField>
      <BookingTextField
        id="email_input"
        label={i18n.t('booking.templates.email')}
        type="email"
        name="email"
        value={value}
        required={required}
        onChange={handleChange}
        error={emailErrors?.[0]}
        autoComplete="email"
        disabled={disable}
      />
    </BookingField>
  )
}

EmailInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired
  })
}

export default EmailInput
